import { useDroppable } from '@dnd-kit/core';
import styles from '../InterventionGraphEditor.module.css';

interface GapDropZoneProps {
  id: string;
  active: boolean;
  strokeColor: string;
}

export const GapDropZone = ({ id, active, strokeColor }: GapDropZoneProps) => {
  const { setNodeRef, isOver } = useDroppable({ id });
  return (
    <div
      ref={setNodeRef}
      className={`${styles.gap} ${active ? styles.gapActive : ''} ${isOver && active ? styles.gapOver : ''}`}
    >
      {active && (
        <div
          className={styles.gapIndicator}
          style={{ backgroundColor: isOver ? strokeColor : undefined }}
        />
      )}
    </div>
  );
};
